<script>
import useFanPublicationStore from "%/dynamic-component-editor/stores/fan-publication-store";
import { mapState } from "pinia";
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";
import FallbackImageOptions from "%/dynamic-component-editor/bundles/fallback-image-options";
import { CONTRAST_DARK_MODE } from "%/dynamic-component-editor/constants/color-palette-editor-constants";

export default {
  name: "PublicationLogo",
  extends: BaseImageElement,
  mixins: [FallbackImageElementMixin],
  optionBundles: [
    new FallbackImageOptions({
      "default.crop": false,
    }, {
      "crop": true,
    }),
  ],
  elementPanelSettings: {
    tags: ["logo", "brand", "publication"],
    displayName: "Logo",
    elementGroup: "general",
    displayIcon: "image",
    elementType: "element",
  },
  computed: {
    imageSrc() {
      if (this.themeMode === CONTRAST_DARK_MODE) {
        return this.publicationLogoDark;
      }
      return this.publicationLogo;
    },
    ...mapState(useFanPublicationStore, ["publicationLogo", "publicationLogoDark"]),
  },
};
</script>
